export default __webpack_public_path__ + "815b18d8dfed4addc238f95c8cfdbdd2.jpg";